import { useState } from 'react';
import { Modal, ModalHeader, ModalFooter, ModalBody, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import SelectClient from 'components/widgets/form/SelectClient';
import { useTranslation } from 'react-i18next';

import useClientSelector from 'service/apicataleg/useClientSelector';

const ModalClient = ({ show, toggleFunc }) => {
  const [selectedOption, setSelectedOption] = useState({ client: {}, marques: [], carts: [] });
  const { t } = useTranslation('common');
  const { selectClient } = useClientSelector();

  const handleSelectChange = (selOption) => {
    setSelectedOption(selOption);
  };

  const handleSelectBtn = (evt) => {
    const { codi } = selectedOption;
    selectClient(codi).then(toggleFunc());
  };

  return (
    <Modal isOpen={show} toggle={toggleFunc}>
      <ModalHeader toggle={toggleFunc}>{t('modalClient.title')}</ModalHeader>
      <ModalBody>
        <SelectClient
          placeholder={t('modalClient.inputPlaceholder')}
          onChange={(c) => {
            handleSelectChange(c);
          }}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSelectBtn}>
          {t('buttons.selectClient')}
        </Button>
        <Button onClick={toggleFunc}>{t('buttons.cancel')}</Button>
      </ModalFooter>
    </Modal>
  );
};

ModalClient.propTypes = {
  show: PropTypes.bool,
  toggleFunc: PropTypes.func,
};

export default ModalClient;
